/*!
 * PreviewView - Vue avec volet d'aperçu latéral pour IconsView
 */

import CardView from './CardView';

export default class PreviewView extends CardView {
    constructor(plugin) {
        super(plugin, 'preview');
    }

    createContainer(element) {
        const myself = this.plugin;
        this.container = $('<div></div>');
        myself.container = this.container;
        myself.preview = $('<div class="iv__preview private"></div>');

        if (myself.options && myself.options.event && myself.options.event.leftClick !== 'select1') {
            myself.options.event.backup = clone(myself.options.event);
            myself.options.event.doubleClick = myself.options.event.leftClick;
            myself.options.event.leftClick = 'select1';
        }

        myself.containerView.addClass('iv__view iv__view--preview view view-preview');
        element.append(this.container);
        if (myself.preview) {
            element.append(myself.preview);
        }

        return this.container;
    }

    renderIcon(data, container, subdir, path) {
        const myself = this.plugin;
        if (data.type === 'root') return true;

        myself.viewItemThumbsMode = false;
        const currentViewConf = myself.getViewConfig('preview') || {};
        const currentIconSize = myself.getViewIconSize('preview');

        myself.viewThumbsHeight = currentIconSize;
        myself.viewThumbsWidth = currentIconSize;
        myself.viewItemWidthRatio = currentViewConf.ratio || 0;
        myself.viewItemWidthMin = currentViewConf.minWidth || 200;
        myself.viewItemWidthMax = currentViewConf.maxWidth || 400;

        const currentType = this.getTypes(data);
        const currentClassAll = this.buildItemClasses(data, currentType, (data.class || data.cls || ''));

        const previewFields = myself.getViewFields('preview') || myself.getViewFields('mosaic');
        const codeSubtext = this.buildFieldsSubtext(data, previewFields);

        let countHtml = '';
        if (myself.shouldShowCount(data, 'preview')) {
            countHtml = ' <span class="iv__item__count">(' + data.count + ')</span>';
        }

        const code = '<div class="' + currentClassAll + '"><div class="iv__item__frame"><span class="iv__item__link"><span class="iv__item__image">' + myself.renderIconImage(myself.viewThumbsWidth, data.icon, data, 'img') + '</span> '
                + '<label class="iv__item__label">'
                + '<span class="iv__item__name titre">' + data.label + '</span>'
                + countHtml
                + ((codeSubtext.length > 0) ? '<span class="iv__item__data infos">' + codeSubtext.join('') + '</span>' : '')
                + '</label></span></div></div>';

        const currentIcon = $(code);
        container.append(currentIcon);
        this.attachItemEvents(currentIcon, currentIcon, data, currentType, path);
        this.renderBadge(data, currentIcon);

        return currentIcon;
    }
}
